/* eslint-disable camelcase */
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import SimpleSelectionTable, { SimpleFilterField } from 'components/datatable/SimpleSelectionTable'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { normalizeString } from 'utils/StringUtil'

const HEADERS_COMMUNES = ['name', 'code', 'email']

const DialogCities = ({
    open = false,
    onClose = () => {},
    onValidate = () => {},

    cities = [],
    selectedCities = [],
    setSelectedCities = () => {},
}) => {
    const filterFunction = (list, { searchValue = '' }) => {
        const searchValueFormat = normalizeString(searchValue)
        return searchValue ? list.filter(p => normalizeString(p.labelWithCode).includes(searchValueFormat)) : list
    }

    return (
        <Dialog open={open} maxWidth={'lg'}>
            <DefaultDialogTitle title={i18n.addCity} onClose={onClose}/>
            <DialogContent>
                <SimpleSelectionTable
                    listHeaders={HEADERS_COMMUNES}
                    listTitle={i18n.cityList}
                    selectedListTitle={i18n.citySelected}

                    listData={cities}
                    selectedList={selectedCities}

                    onChange={setSelectedCities}

                    filterField={SimpleFilterField}
                    filterFunction={filterFunction}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogCities.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    cities: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        code: PropTypes.string,
        name: PropTypes.string,
        labelWithCode: PropTypes.string,
        departmentNumber: PropTypes.string,
        area: PropTypes.number,
        countryCode: PropTypes.string,
        x: PropTypes.number,
        y: PropTypes.number,
        projection: PropTypes.number,
        email: PropTypes.string,
        phone: PropTypes.string,
        population: PropTypes.number,
        kml: PropTypes.string,
        siren: PropTypes.string,
        creationDate: PropTypes.number,
        sispeaCode: PropTypes.string,
        address: PropTypes.string,
        addressComplement: PropTypes.string,
        postalCode: PropTypes.string,
        openHours: PropTypes.string,
        agency: PropTypes.number,
        skillAEP: PropTypes.bool,
        codeSkillAEP: PropTypes.string,
        addressFunction: PropTypes.number,
        addressCityName: PropTypes.string,
        link_postalCode: PropTypes.arrayOf(PropTypes.string),
        link_contacts: PropTypes.arrayOf(PropTypes.shape({
            cityCode: PropTypes.string,
            contactCode: PropTypes.number,
        })),
        link_populations: PropTypes.arrayOf(PropTypes.shape({
            cityCode: PropTypes.string,
            year: PropTypes.number,
            inseeTotal: PropTypes.number,
            inseeTotalAuto: PropTypes.bool,
            temporaryResident: PropTypes.number,
            temporaryResidentAuto: PropTypes.bool,
            increasedTotal: PropTypes.number,
            increasedTotalAuto: PropTypes.bool,
        })),
        headers: PropTypes.arrayOf(PropTypes.string),
    })),
    selectedCities: PropTypes.arrayOf(PropTypes.string),
    setSelectedCities: PropTypes.func,
}

export default DialogCities